import React, { useMemo } from 'react';

import Button from '../../common/button';

import { LoginLink } from '../../signup/confirmEmail/style';
import { getLoginUrl } from '../../../utils/utilities';

import {
  ButtonWrapper,
  DescriptionMessage,
  ErrorImageLogo,
  ErrorTypeTitle,
  Img,
  Wrapper,
} from './styles';

interface Props {
  image: string;
  title: string;
  description?: string;
  buttonText: string;
  onButtonClick: () => void;
  onLoginClick?: () => void;
  lang?: string;
  discountInfo?: unknown;
  tiering?: unknown;
  haveAnAccountText: string;
  logInLinkLabel: string;
}

const PartnerError = ({
  image,
  title,
  description,
  buttonText,
  onButtonClick,
  onLoginClick,
  lang,
  discountInfo,
  tiering,
  haveAnAccountText,
  logInLinkLabel,
}: Props) => {
  const loginPage = useMemo(
    () => getLoginUrl(discountInfo, lang, true, tiering),
    [discountInfo, lang, tiering]
  );

  const handleLoginClick = (e: { preventDefault: () => void; }) => {
    if (onLoginClick) {
      e.preventDefault();
      onLoginClick();
      window.location.href = loginPage;
    }
  }

  return (
    <Wrapper id="partner-signup-error-Wrapper">
      <ErrorImageLogo>
        <Img src={image} alt="partner signup error image" />
      </ErrorImageLogo>

      <ErrorTypeTitle>{title}</ErrorTypeTitle>

      {description && <DescriptionMessage>{description}</DescriptionMessage>}
      <ButtonWrapper id="partner-signup-error-button-wrapper">
        <Button variant="contained" className="submit-button uppercase" onClick={onButtonClick}>
          <>{buttonText}</>
        </Button>
      </ButtonWrapper>
      {haveAnAccountText && logInLinkLabel && (
        <LoginLink id="have-an-account">
          {haveAnAccountText}
          <a href={loginPage} id="log-in-link" onClick={handleLoginClick}>
            {logInLinkLabel}
          </a>
        </LoginLink>
      )}
    </Wrapper>
  );
};

export default PartnerError;
